<template>
  <div class="container">
    <div>

        <div>
        <p><b>PERSONAL DATA PROTECTION NOTICE</b></p>
        <p class="lightColor"><i>NOTIS PERLINDUNGAN DATA PERIBADI</i></p>
        <p style="margin-top:24px"><b>Dear Valued Users and Guests,</b></p>
        <p class="lightColor"><i>Pengguna-Pengguna dan Tetamu-Tetamu yang dihargai,</i></p>
        <p>
          <b
            >This Personal Data Protection Notice (“Notice”) is issued to all
            valued users and guests of Carsome Sdn Bhd and its affiliate
            (“Carsome”) pursuant to the Personal Data Protection Act 2010 [Act
            709] (“PDPA”).</b
          >
        </p>
        <p class="lightColor">
          <i
            >Notis Perlindungan Data Peribadi ini (“Notis”) dikeluarkan untuk
            semua Pengguna-Pengguna dan Tetamu-Tetamu yang dihargai Carsome Sdn
            Bhd dan afiliasinya (“Carsome”) menurut Akta Perlindungan Data
            Peribadi 2010 [Akta 709] (“PDPA”).</i
          >
        </p>

        <ul class="switch">
          <li>
            <p>
              <b
                >2.&nbsp;&nbsp;&nbsp;During your course of dealing with us, we
                will ct and process your personal data for purposes,
                including, to communicate with you, provide products and/or
                services to you, respond to your enquiries, provide information
                and updates on our products, services and promotions offered by
                Carsome and other purposes required to operate and maintain our
                business as set out in our Personal Data Protection Policy
                (collectively referred to as “Purposes”).</b
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >2.&nbsp;&nbsp;&nbsp;Sepanjang masa urusan anda dengan kami,
                kami akan mengumpul dan memproses data peribadi anda untuk
                tujuan berkomunikasi dengan anda, menyediakan produk dan/atau
                perkhidmatan kepada anda, memberi maklum balas terhadap
                pertanyaan anda, memberi anda maklumat terkini mengenai produk,
                perkhidmatan dan/atau promosi yang ditawarkan oleh Carsome serta
                tujuan-tujuan lain yang diperlukan untuk mengendali dan
                mengekalkan perniagaan kami sepertimana yang tertera di Polisi
                Perlindungan Data Peribadi kami (secara kolektifnya dirujuk
                sebagai “Tujuan-Tujuan”).</i
              >
            </p>
          </li>
          <li>
            <p>
              <b
                >3.&nbsp;&nbsp;&nbsp;We are committed to ensuring that your
                personal data is stored securely. You have the right to request
                for access to, request for a copy of, request to update or
                correct your personal data held by us. You have the right at any
                time to request us to limit the processing and use of your
                personal data. Your written request should be addressed to our
                Compliance Officer at &lt;info@carsome.my&gt;.</b
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >3.&nbsp;&nbsp;&nbsp;Kami berkomited untuk memastikan bahawa
                data peribadi anda akan disimpan dengan selamat. Anda berhak
                untuk meminta akses, meminta salinan, meminta untuk mengemas
                kini atau memperbetulkan data peribadi anda yang disimpan oleh
                kami. Anda mempunyai hak pada bila-bila masa untuk meminta kami
                mengehadkan pemprosesan dan penggunaan data peribadi anda.
                Permintaan bertulis anda boleh ditujukan kepada Pegawai
                Pematuhan kami di &lt;info@carsome.my&gt;.</i
              >
            </p>
          </li>
          <li>
            <p>
              <b
                >4.&nbsp;&nbsp;&nbsp;This Notice is provided in English and
                Malay languages and should there be any conflict in meaning
                between the English and Malay language version, the English
                language version shall prevail. By accessing this website and/or
                submitting your personal data to us, you are deemed to have
                read, understood and accepted the terms of this Notice, and
                consent to the collection and processing of your personal data
                by Carsome as per this Notice and our Personal Data Protection
                Policy.</b
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >4.&nbsp;&nbsp;&nbsp;Notis ini disediakan dalam Bahasa Inggeris
                dan Bahasa Melayu dan sekiranya terdapat konflik makna antara
                versi Bahasa Inggeris dan Bahasa Melayu, versi bahasa Inggeris
                akan digunapakai. Dengan mengakses laman web ini dan/atau
                menyerahkan data peribadi anda kepada kami, anda dianggap telah
                membaca, memahami dan menerima syarat-syarat Notis ini, dan
                memberikan persetujuan untuk pengumpulan dan pemprosesan data
                peribadi anda oleh Carsome sejajar dengan Notis ini dan Polisi
                Perlindungan Data Peribadi.</i
              >
            </p>
          </li>
          <li>
            <p>
              <b
                >5.&nbsp;&nbsp;&nbsp;We reserve the right to update and amend
                this Personal Data Protection Notice and our Personal Data
                Protection Policy from time to time. We will notify you of any
                amendments via announcements on our website or other appropriate
                means.</b
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >5.&nbsp;&nbsp;&nbsp;Kami berhak untuk mengemaskini dan meminda
                Notis Perlindungan Data Peribadi ini dan Polisi Perlindungan
                Data Peribadi kami dari semasa ke semasa. Sebarang perubahan
                atau pemindaan kepada Notis Privasi Data Peribadi ini atau
                Polisi Privasi Data Peribadi kami akan dimaklumkan di laman web
                kami atau melalui cara lain yang bersesuaian.</i
              >
            </p>
          </li>
        </ul>
        <p></p>
        <p><b>Dated: January 1, 2021</b></p>
        <p><i>Bertarikh: January 1, 2021</i></p>
        <p>&nbsp;</p>
        <h2>PERSONAL DATA PROTECTION POLICY</h2>
        <h2>1. INTRODUCTION</h2>
        <ul>
          <li>
            <p>
              1.1 This Policy applies to personal information about individuals
              (including but not limited to customers, vendors, distributors,
              suppliers, service providers, joint venture/business partners, job
              applicants, employees) held by us. We will only process your
              Personal Data in accordance with the Personal Data Protection Act
              2010 [Act 709], the applicable regulations, guidelines, orders
              made under the Act 709 and any statutory amendments or
              re-enactments made of the Personal Data Protection Act 2010 from
              time to time (collectively referred to as the “PDPA”) as well as
              this Policy.
            </p>
          </li>
          <li>
            <p>
              1.2 By providing your Personal Data to us and/or continuing to
              access and use our website (“Site”), you declare that you have
              read and understood this Policy and agree to us processing your
              Personal Data in accordance with the manner as set out in this
              Policy.
            </p>
          </li>
          <li>
            <p>
              1.3 We reserve the right to modify, update and/or amend this
              Policy from time to time with reasonable prior notice to you. We
              will notify you of any amendments via announcements on the Site or
              other appropriate means. Please check the Site from time to time
              to see if there are amendments to this Policy.
            </p>
          </li>
          <li>
            <p>
              1.4 In the event you do not agree to this Policy or any amendments
              to this Policy, we may not be able to render all services to you
              and you may be required to terminate your relevant agreement with
              us and/or stop accessing or using the Site.
            </p>
          </li>
        </ul>
        <h2>2. COLLECTION</h2>
        <ul class="sub">
          <li>
            <p>
              2.1 The term “Personal Data” means any information in our
              possession or control that relates directly or indirectly to an
              individual to the extent that the individual can be identified or
              are identifiable from that and other information in our
              possession, such as name, address, telephone number,
              Identification/Passport number, date of birth, photograph, email
              address, household information, etc. as well as Sensitive Personal
              Data as defined under the PDPA, which includes but is not limited
              to, information pertaining to the physical or mental health or
              condition of a data subject and religious beliefs.
            </p>
          </li>
          <li>
            <p>
              2.2 The types of Personal Data collected depend on the purpose of
              collection. We may process your Personal Data by way of
              collecting, recording, holding, storing, using and/or disclosing
              it.
            </p>
          </li>
          <li>
            <p>
              2.3 Your Personal Data may be collected from you during your
              course of dealings with us in any way or manner including pursuant
              to any transactions and/or communications made from/with us. We
              may also collect your Personal Data from a variety of sources,
              including without limitation, at any events, seminars, road shows,
              customer satisfaction surveys organised and/or sponsored by us, as
              well as from publicly available sources.
            </p>
          </li>
          <li>
            <p>
              2.4 In addition, we may also receive, store and process your
              Personal Data which are provided or made available by any third
              parties, credit reference bodies, regulatory and law enforcement
              authorities, for reasons including delivery of our products and/or
              services, performance of conditions of agreements and/or to comply
              with our legal and regulatory obligations.
            </p>
          </li>
          <li>
            <p>
              2.5 The Personal Data as provided/furnished by you to us or
              collected by us from you or through such other sources as may be
              necessary for the fulfilment of the purposes at the time it was
              sought or collected, may be processed for the following purposes
              (collectively referred to as the “Purposes”):
            </p>
            <ul>
              <li><p>a. to communicate with you;</p></li>
              <li><p>b. to maintain and improve customer relationship;</p></li>
              <li>
                <p>
                  c. to assess, process and provide products, services and/or
                  facilities to you;
                </p>
              </li>
              <li>
                <p>
                  d. to administer and process any payments related to products,
                  services and/or facilities requested by you;
                </p>
              </li>
              <li><p>e. to establish your identity and background;</p></li>
              <li>
                <p>
                  f. to respond to your enquiries or complaints and resolve any
                  issues and/or disputes which may arise in connection with any
                  dealings with us;
                </p>
              </li>
              <li>
                <p>
                  g. to provide you with information and/or updates on our
                  products, services, upcoming promotions offered by us and/or
                  events organised by us and selected third parties which may be
                  of interest to you from time to time;
                </p>
              </li>
              <li>
                <p>
                  h. for direct marketing purposes via SMS, phone call, email,
                  fax, mail, social media and/or any other appropriate
                  communication channels;
                </p>
              </li>
              <li>
                <p>
                  i. to facilitate your participation in, and our administration
                  of, any events including contests, promotions or campaigns;
                </p>
              </li>
              <li>
                <p>j. to award points in a loyalty or rewards programme;</p>
              </li>
              <li><p>k. to maintain and update internal record keeping;</p></li>
              <li><p>l. for internal administrative purposes;</p></li>
              <li>
                <p>
                  m. to send you seasonal greetings messages from time to time;
                </p>
              </li>
              <li>
                <p>
                  n. to send you the invitation to join our events, promotions
                  and product launch events;
                </p>
              </li>
              <li>
                <p>
                  o. to monitor, review and improve our events, promotions,
                  products and/or services;
                </p>
              </li>
              <li>
                <p>
                  p. to conduct credit reference checks and establish your
                  creditworthiness, where necessary, in providing you with the
                  products, services and/or facilities;
                </p>
              </li>
              <li>
                <p>
                  q. to administer and give effect to your commercial
                  transactions with us (such as a tender award, contract for
                  service, tenancy agreement);
                </p>
              </li>
              <li>
                <p>
                  r. to process any payments related to your commercial
                  transactions with us;
                </p>
              </li>
              <li>
                <p>
                  s. to process and analyse your Personal Data either
                  individually or collectively with other individuals;
                </p>
              </li>
              <li>
                <p>
                  t. to conduct market research or surveys, internal marketing
                  analysis, customer profiling activities, analysis of customer
                  patterns and choices, planning and statistical and trend
                  analysis in relation to our products and/or services;
                </p>
              </li>
              <li>
                <p>
                  u. to share any of your Personal Data with the auditor for our
                  internal audit and reporting purposes;
                </p>
              </li>
              <li>
                <p>
                  v. to share any of your Personal Data pursuant to any
                  agreement or document which you have duly entered with us for
                  purposes of seeking legal and/or financial advice and/or for
                  purposes of commencing legal action;
                </p>
              </li>
              <li>
                <p>
                  w. to share any of your Personal Data with our joint
                  venture/business partners to jointly develop products and/or
                  services or launch marketing campaigns;
                </p>
              </li>
              <li>
                <p>
                  x. to share any of your Personal Data with insurance companies
                  necessary for the purpose of applying and obtaining insurance
                  policy(ies), if necessary;
                </p>
              </li>
              <li>
                <p>
                  y. to share any of your Personal Data with financial
                  institutions necessary for the purpose of applying and
                  obtaining credit facility(ies), if necessary;
                </p>
              </li>
              <li>
                <p>z. for audit, risk management and security purposes;</p>
              </li>
              <li>
                <p>
                  aa. for detecting, investigating and preventing fraudulent,
                  prohibited or illegal activities;
                </p>
              </li>
              <li>
                <p>
                  bb. for enabling us to perform our obligations and enforce our
                  rights under any agreements or documents that we are a party
                  to;
                </p>
              </li>
              <li>
                <p>
                  cc. to transfer or assign our rights, interests and
                  obligations under any agreements entered into with us;
                </p>
              </li>
              <li>
                <p>
                  dd. for meeting any applicable legal or regulatory
                  requirements and making disclosure under the requirements of
                  any applicable law, regulation, direction, court order,
                  by-law, guideline, circular or code applicable to us;
                </p>
              </li>
              <li>
                <p>
                  ee. to enforce or defend our rights and your rights under, and
                  to comply with, our obligations under the applicable laws,
                  legislation and regulations;
                </p>
              </li>
              <li>
                <p>
                  ff. to carry out verification and background checks as part of
                  any recruitment and selection process in connection with your
                  application for employment with us; and/or
                </p>
              </li>
              <li>
                <p>
                  gg. for other purposes required to operate, maintain and
                  better manage our business and your relationship with us,
                  which we notify you of at the time of obtaining your consent;
                  and you agree and consent to us using and processing your
                  Personal Data for the Purposes in the manner as identified in
                  this Policy. If you do not consent to us processing your
                  Personal Data for one or more of the Purposes, please notify
                  us at the contact details below.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              2.6 The collection of your Personal Data by us may be mandatory or
              voluntary in nature depending on the Purposes for which your
              Personal Data is collected. Where it is obligatory for you to
              provide us with your Personal Data, and you fail or choose not to
              provide us with such data, or do not consent to the above or this
              Policy, we will not be able to provide products and/or services or
              otherwise deal with you.
            </p>
          </li>
        </ul>
        <h2>3. DISCLOSURE</h2>
        <p></p>
        <p>
          We will not sell, rent, transfer or disclose any of your Personal Data
          to any third party without your consent. However, we may disclose your
          Personal Data to the following third parties, for one or more of the
          above Purposes:
        </p>
        <ul>
          <li>
            <p>
              a. Between Carsome and our related corporations and affiliates
              either in Malaysia or overseas;
            </p>
          </li>
          <li>
            <p>
              b. your immediate family members and/or emergency contact person
              as may be notified to us from time to time;
            </p>
          </li>
          <li><p>c. successors in title to us;</p></li>
          <li>
            <p>
              d. any person under a duty of confidentiality which we have
              engaged to discharge our obligations to you, to whom has
              undertaken to keep your Personal Data confidential;
            </p>
          </li>
          <li>
            <p>
              e. any party in relation to legal proceedings or prospective legal
              proceedings;
            </p>
          </li>
          <li>
            <p>
              f. our auditors, consultants, lawyers, accountants or other
              financial or professional advisers appointed in connection with
              our business on a strictly confidential basis, appointed by us to
              provide services to us;
            </p>
          </li>
          <li>
            <p>
              g. any party nominated or appointed by us either solely or jointly
              with other service providers, for purpose of establishing and
              maintaining a common database where we have a legitimate common
              interest;
            </p>
          </li>
          <li>
            <p>
              h. data centres and/or servers located within or outside Malaysia
              for data storage purposes or otherwise;
            </p>
          </li>
          <li>
            <p>
              i. payment channels including but not limited to financial
              institutions for purpose of assessing, verifying, effectuating and
              facilitating payment of any amount due to us in connection with
              your purchase of our products and/or services;
            </p>
          </li>
          <li>
            <p>
              j. government agencies, law enforcement agencies, courts,
              tribunals, regulatory bodies, industry regulators, ministries,
              and/or statutory agencies or bodies, offices or municipality in
              any jurisdiction, if required or authorised to do so, to satisfy
              any applicable law, regulation, order or judgment of a court or
              tribunal or queries from the relevant authorities;
            </p>
          </li>
          <li>
            <p>
              k. our joint venture/business partners, third-party product and/or
              service providers, suppliers, vendors, contractors, data
              processors or agents, that provide related products and/or
              services in connection with our business, or discharge or perform
              one or more of the above Purposes and other purposes required to
              operate and maintain our business, including but not limited to
              call centres, telecommunication companies, logistics companies,
              information technology companies and data centres; insurance
              companies for the purpose of applying and obtaining insurance
              policy(ies), if necessary;
            </p>
          </li>
          <li>
            <p>
              l. financial institutions for the purpose of applying and
              obtaining credit facility(ies), if necessary;
            </p>
          </li>
          <li>
            <p>
              m. financial institutions, merchants and credit card organisations
              in connection with your commercial transactions with us;
            </p>
          </li>
          <li>
            <p>
              n. the general public when you become a winner in a contest by
              publishing your name, photographs and other Personal Data without
              compensation for advertising and publicity purposes;
            </p>
          </li>
          <li>
            <p>
              o. to third-party credit reporting or employment agencies as part
              of the recruitment and selection process and/or otherwise in
              connection with your application for employment with us;
            </p>
          </li>
          <li>
            <p>
              p. in the event of a potential, proposed or actual sale/disposal
              of any of our business or interest, merger, acquisition,
              consolidation, re-organisation, funding exercise or asset sale
              relating to us, or in the event of winding-up (“Transaction”),
              your Personal Data may be required to be disclosed or transferred
              to a third party as a result of or in connection with, the
              Transactions.
            </p>
          </li>
          <li>
            <p>
              q. You hereby acknowledge that such disclosure and transfer may
              occur and permit us to disclose and transfer your Personal Data to
              such third party and its advisors/representatives and/or any other
              person reasonably requiring the same in order for us to operate
              and maintain our business or carry out the activities set out in
              the Purposes.
            </p>
          </li>
        </ul>
        <h2>4. ACCURACY</h2>
        <p></p>
        <p>
          We aim to keep all Personal Data as accurate, complete, not
          misleading, up-to-date and reliable as possible. Therefore, the
          accuracy of your Personal Data depends to a large extent on the
          information you provide. As such, it is a condition of us providing
          the products, services and/or facilities to you that you:
        </p>
        <ul>
          <li>
            <p>
              a. warrant and declare that all your Personal Data submitted or to
              be submitted to us are accurate, not misleading, updated and
              complete in all respects for purposes of acquiring or using the
              relevant products, services and/or facilities, and you have not
              withheld any Personal Data which may be material in any respect
              and that we are authorised to assume the accuracy and
              up-to-dateness of the Personal Data given by you when processing
              such Personal Data); and
            </p>
          </li>
          <li>
            <p>
              b. promptly update us as and when such Personal Data provided
              earlier to us becomes inaccurate, incomplete, misleading, outdated
              or changes in any way whatsoever by contacting us at the contact
              details below.
            </p>
          </li>
        </ul>
        <h2>5. ACCESS</h2>
        <ul>
          <li>
            <p>
              5.1 Subject to the exceptions provided under the PDPA, you have
              the right to request for access to, for a copy of, to update or
              correct, your Personal Data held by us. We may charge a small fee
              (such amount as permitted by the PDPA) to cover the administration
              costs involved in processing your request to access your Personal
              Data.
            </p>
          </li>
          <li>
            <p>
              5.2 In respect of your right to access and/or correct your
              Personal Data, we have the right to refuse your request to access
              and/or correct your Personal Data for the reasons permitted under
              the law, such as where the expense of providing access to you is
              disproportionate to the risks to your privacy, or where the rights
              of others may also be violated, amongst other reasons.
            </p>
          </li>
          <li>
            <p>
              5.3 You have the right at any time to request us to limit the
              processing and use of your Personal Data (for example, requesting
              us to stop sending you any marketing and promotional materials or
              contacting you for marketing purposes).
            </p>
          </li>
          <li>
            <p>
              5.4 In addition, you also have the right, by notice in writing, to
              inform us on your withdrawal (in full or in part) of your consent
              given previously to us subject to any applicable legal
              restrictions, contractual conditions and a reasonable duration of
              time for the withdrawal of consent to be affected. However, your
              withdrawal of consent could result in certain legal consequences
              arising from such withdrawal. In this regard, depending on the
              extent of your withdrawal of consent for us to process your
              Personal Data, it may mean that we will not be able to continue
              with your existing relationship with us and/or the contract that
              you have with us will have to be terminated.
            </p>
          </li>
        </ul>
        <h2>6. RETENTION</h2>
        <p>
          Any of your Personal Data provided to us is retained for as long as
          the Purposes for which the Personal Data was collected continues. Your
          Personal Data will be destroyed from our records and system in
          accordance with our retention policy in the event your Personal Data
          is no longer required for the said purposes unless its further
          retention is required to satisfy a longer retention period to meet our
          operational, legal, regulatory, tax or accounting requirements.
        </p>
        <h2>7. SECURITY</h2>
        <ul>
          <li>
            <p>
              7.1 We are committed to ensuring that your Personal Data is stored
              securely. In order to prevent unauthorised access, disclosure or
              other similar risks, we endeavour, where practicable, to implement
              appropriate technical, physical, electronic and procedural
              security measures in accordance with the applicable laws and
              regulations and industry standard to safeguard against and prevent
              the unauthorised or unlawful processing of your Personal Data, and
              the destruction of, or accidental loss, damage to, alteration of,
              unauthorised disclosure of or access to your Personal Data.
            </p>
          </li>
          <li>
            <p>
              7.2 We will make reasonable updates to its security measures from
              time to time and ensure the authorised third parties only use your
              Personal Data for the Purposes set out in this Policy.
            </p>
          </li>
          <li>
            <p>
              7.3 The Internet is not a secure medium. However, we will put in
              place various security procedures with regard to the Site and your
              electronic communications with us. All our employees, joint
              venture/business partners, agents, contractors, vendors,
              suppliers, data processors, third-party product and/or service
              providers, who have access to, and are associated with the
              processing of your Personal Data, are obliged to respect the
              confidentiality of your Personal Data.
            </p>
          </li>
          <li>
            <p>
              7.4 Please be aware that communications over the Internet, such as
              emails/webmails are not secure unless they have been encrypted.
              Your communications may be routed through a number of countries
              before being delivered – this is the nature of the World Wide
              Web/Internet.
            </p>
          </li>
          <li>
            <p>
              7.5 We cannot and do not accept responsibility for any
              unauthorised access or interception or loss of Personal Data that
              is beyond our reasonable control.
            </p>
          </li>
        </ul>
        <h2>8. TRANSFER OUTSIDE OF MALAYSIA</h2>
        <p>
          Our information technology storage facilities and servers may be
          located in other jurisdictions outside of Malaysia. This may include,
          but not limited to, instances where your Personal Data may be stored
          on servers located outside Malaysia. In addition, your Personal Data
          may be disclosed or transferred to entities located outside Malaysia
          or where you access the Site from countries outside Malaysia. Please
          note that these foreign entities may be established in countries that
          might not offer a level of data protection that is equivalent to that
          offered in Malaysia under the laws of Malaysia. You hereby expressly
          consent to us transferring your Personal Data outside of Malaysia for
          such purposes. We shall endeavour to ensure that reasonable steps are
          taken to procure that all such third parties outside of Malaysia shall
          not use your Personal Data other than for that part of the Purposes
          and to adequately protect the confidentiality and privacy of your
          Personal Data.
        </p>
        <h2>9. EXTERNAL LINKS</h2>
        <ul>
          <li>
            <p>
              9.1 If any part of the Site links you to other websites, those
              websites do not operate under this Policy and we do not accept any
              responsibility or liability arising from those websites.
            </p>
          </li>
          <li>
            <p>
              9.2 Likewise, if you subscribe to an application, content or a
              product from our strategic partner and you subsequently provide
              your Personal Data directly to that third party, that Personal
              Data will be subject to that third party’s privacy/personal data
              protection policy (if they have such a policy) and not to this
              Policy.
            </p>
          </li>
          <li>
            <p>
              9.3 We recommend you to read and understand the privacy/personal
              data protection statement/policy posted on those other websites in
              order to understand their procedures for collecting, processing,
              using and disclosing personal data and before submitting your
              Personal Data to those websites.
            </p>
          </li>
        </ul>
        <h2>10. COOKIES</h2>
        <ul>
          <li>
            <p>
              10.1 We employ an industry standard technology called “cookies”.
              The cookie is a small piece of information stored on the hard
              drive of your computer or device for record-keeping purposes and
              is used by us to track your visits to the Site. Cookies may be
              used to save your preferences for your ease and convenience when
              using the Site. Third party advertising networks may issue their
              separate cookies to your hard drive when serving advertisements.
            </p>
          </li>
          <li>
            <p>
              10.2 The type of anonymous clickstream data collected by us
              through the cookies may include your Internet Protocol address,
              web browser software, date and time of visit to the Site, and
              whether your requests (including search requests and clicking on
              links to parts of the Site) were met with success. All such
              information collected through cookies is not Personal Data and you
              cannot be identified from this information. Such information is
              only used for the purpose of managing and creating a better user
              experience and to identify areas for improvement on the Site.
            </p>
          </li>
          <li>
            <p>
              10.3 The use of cookies is now an industry standard, and you will
              find them used on most major websites. Most browsers are initially
              set up to accept cookies. If you prefer, you can reset your
              browser either to notify you when you have received a cookie or to
              refuse to accept cookies. You should understand that certain
              features on the Site will not function properly if you set your
              browser to not accept cookies.
            </p>
          </li>
        </ul>
        <h2>11. CONTACT</h2>
        <p>
          In the event you have any questions about this Policy, have any
          further queries, or would like to make a complaint, data access,
          correction request in respect of your Personal Data, you may contact
          our Compliance Officer at &lt;info@carsome.my&gt;.
        </p>
        <h2>12. LANGUAGE</h2>
        <p>
          In the event of any conflict between this English language Personal
          Data Privacy Policy and its corresponding Bahasa Malaysia Personal
          Data Privacy Policy, the terms in this English language Personal Data
          Privacy Policy shall prevail.
        </p>
        <h2>Dated: January 1, 2021</h2>
        <p></p>
        <h2><i>POLISI PERLINDUNGAN DATA PERIBADI</i></h2>
        <h2><i>1. PENGENALAN</i></h2>
        <ul>
          <li>
            <p>
              <i
                >1.1 Polisi ini terpakai kepada maklumat peribadi mengenai
                individu (termasuk tetapi tidak terhad kepada pelanggan,
                penjual, pengedar, pembekal, pembekal perkhidmatan, rakan kongsi
                usaha sama/perniagaan, pemohon kerja, pekerja) yang dipegang
                oleh kami. Kami hanya akan memproses Data Peribadi anda selaras
                dengan Akta Perlindungan Data Peribadi 2010 [Akta 709],
                peraturan, garis panduan, perintah yang dibuat di bawah Akta 709
                dan sebarang pindaan berkanun atau enakmen yang diperbuat
                daripada Akta Perlindungan Data Peribadi 2010 dari semasa ke
                semasa (secara kolektif dirujuk sebagai “APDP”) serta Polisi
                ini.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >1.2 Dengan membekalkan Data Peribadi anda kepada kami dan/atau
                dengan terus mengakses dan menggunakan laman web kami (“Laman
                Web”), anda mengisytiharkan bahawa anda telah membaca dan
                memahami Polisi ini dan bersetuju dengan pemprosesan Data
                Peribadi anda mengikut cara yang ditetapkan dalam Polisi ini.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >1.3 Kami berhak untuk mengubahsuai, mengemaskini dan /atau
                meminda Polisi ini dari semasa ke semasa dengan memberi notis
                terdahulu yang munasabah kepada anda. Kami akan memaklumkan anda
                tentang apa-apa pindaan melalui pengumuman di Laman Web atau
                cara lain yang bersesuaian. Sila semak Laman Web dari semasa ke
                semasa untuk mengetahui sama ada terdapat pindaan kepada Polisi
                ini.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >1.4 Jika anda tidak bersetuju dengan Polisi ini atau apa-apa
                pindaan kepada Polisi ini, kami mungkin tidak dapat memberikan
                semua perkhidmatan kepada anda dan anda mungkin dikehendaki
                menamatkan perjanjian anda yang berkaitan dengan kami dan/atau
                berhenti mengakses atau menggunakan Laman Web ini.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>2. PENGUMPULAN</i></h2>
        <ul>
          <li>
            <p>
              <i
                >2.1 Istilah “Data Peribadi” bermaksud apa-apa maklumat dalam
                pemilikan atau kawalan kami yang berkaitan secara langsung atau
                tidak langsung kepada individu setakat mana individu itu boleh
                dikenalpasti atau dikenali melalui maklumat tersebut dan
                maklumat lain dalam pemilikan kami seperti nama, alamat, telefon
                nombor, nombor pengenalan / pasport, tarikh lahir, gambar,
                alamat e-mel, maklumat isi rumah, dan sebagainya, serta Data
                Peribadi Sensitif seperti yang ditakrifkan di bawah PDPA, yang
                termasuk tetapi tidak terhad kepada, maklumat berkaitan dengan
                kesihatan fizikal atau mental subjek data dan kepercayaan
                agama.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >2.2 Jenis Data Peribadi yang dikumpulkan bergantung pada tujuan
                pengumpulan. Kami boleh “memproses” Data Peribadi anda dengan
                cara mengumpul, merekod, memegang, menyimpan, menggunakan dan /
                atau menzahirkannya.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >2.3 Data Peribadi anda boleh dikumpul daripada anda semasa
                urusan anda dengan kami dalam apa cara termasuk melalui sebarang
                transaksi dan/atau komunikasi yang dibuat daripada / dengan
                kami. Kami juga boleh mengumpul Data Peribadi anda daripada
                pelbagai sumber, termasuk tanpa batasan, di sebarang acara,
                seminar, pameran jalan, kajiselidik kepuasan pelanggan yang
                dianjurkan dan/atau ditaja oleh kami, serta dari sumber yang
                tersedia secara umum.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >2.4 Di samping itu, kami juga boleh menerima, menyimpan dan
                memproses Data Peribadi anda yang dibekalkan atau disediakan
                oleh mana-mana pihak ketiga, badan rujukan kredit, pihak
                berkuasa pengawalseliaan dan undang-undang, atas alasan termasuk
                penghantaran produk dan/atau perkhidmatan kami, perlaksanaan
                syarat-syarat perjanjian dan/atau mematuhi obligasi
                undang-undang dan peraturan kami.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >2.5 Data Peribadi yang dibekalkan oleh anda kepada kami atau
                yang dikumpulkan oleh kami dari anda atau melalui sumber-sumber
                lain yang mungkin diperlukan untuk memenuhi tujuan-tujuan pada
                masa ia diminta atau dikumpulkan, boleh diproses untuk
                tujuan-tujuan berikut (secara kolektif dirujuk sebagai
                “Tujuan”):</i
              >
            </p>
            <ul>
              <li>
                <p><i>a. untuk berkomunikasi dengan anda;</i></p>
              </li>
              <li>
                <p>
                  <i
                    >b. untuk mengekalkan dan meningkatkan hubungan
                    pelanggan;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >c. untuk menilai, memproses dan menyediakan produk,
                    perkhidmatan dan / atau kemudahan kepada anda;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >d. untuk membayar dan memproses sebarang bayaran yang
                    berkaitan dengan produk, perkhidmatan dan/atau kemudahan
                    yang anda minta;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i>e. untuk mewujudkan identiti dan latar belakang anda;</i>
                </p>
              </li>
              <li>
                <p>
                  <i
                    >f. untuk bertindak balas kepada pertanyaan atau aduan anda
                    dan menyelesaikan sebarang masalah dan pertikaian yang
                    mungkin timbul berkaitan dengan sebarang urusan dengan
                    kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >g. untuk memberi anda maklumat dan / atau kemas kini
                    mengenai produk, perkhidmatan, promosi yang akan ditawarkan
                    oleh kami dan / atau acara yang dianjurkan oleh kami dan
                    pihak ketiga terpilih yang mungkin menarik minat anda dari
                    semasa ke semasa;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >h. untuk tujuan pemasaran langsung melalui SMS, panggilan
                    telefon, e-mel, faks, surat, media sosial dan / atau
                    mana-mana saluran komunikasi lain yang sesuai;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >i. untuk memudahkan penyertaan anda, dan pentadbiran kami,
                    dalam sebarang acara termasuk pertandingan, promosi atau
                    kempen;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >j. memberi mata anugerah dalam program kesetiaan atau
                    ganjaran;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >k. untuk mengekalkan dan mengemas kini penyimpanan rekod
                    dalaman;</i
                  >
                </p>
              </li>
              <li>
                <p><i>l. untuk tujuan pentadbiran dalaman;</i></p>
              </li>
              <li>
                <p>
                  <i
                    >m. untuk menghantar mesej ucapan bermusim dari semasa ke
                    semasa;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >n. untuk menghantar jemputan menyertai acara dan promosi
                    kami dan acara pelancaran produk kepada anda;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >o. untuk memantau, mengkaji dan memperbaiki acara dan
                    promosi, produk dan / atau perkhidmatan kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >p. untuk menjalankan pemeriksaan rujukan kredit dan
                    mewujudkan kelayakan kredit anda, di mana perlu, dalam
                    menyediakan anda dengan produk, perkhidmatan dan / atau
                    kemudahan;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >q. untuk mentadbir dan menguatkuasakan transaksi komersial
                    anda dengan kami (seperti anugerah tender, kontrak untuk
                    perkhidmatan, perjanjian penyewaan);</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >r. untuk memproses apa-apa bayaran yang berkaitan dengan
                    transaksi komersial anda dengan kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >s. untuk memproses dan menganalisis Data Peribadi anda
                    secara individu atau kolektif dengan individu lain;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >t. untuk menjalankan penyelidikan pasaran atau kaji
                    selidik, analisis pemasaran dalaman, aktiviti profil
                    pelanggan, analisis corak dan pilihan pelanggan, perancangan
                    dan analisis statistik dan trend berhubung dengan produk dan
                    / atau perkhidmatan kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >u. untuk berkongsi mana-mana Data Peribadi anda dengan
                    juruaudit untuk tujuan audit dalaman dan pelaporan kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >v. untuk berkongsi mana-mana Data Peribadi anda menurut
                    mana-mana perjanjian atau dokumen yang anda telah meterai
                    dengan sewajarnya dengan kami untuk mendapatkan nasihat
                    undang-undang dan / atau kewangan dan / atau untuk memulakan
                    tindakan undang-undang;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >w. untuk berkongsi mana-mana Data Peribadi anda dengan
                    rakan usaha sama/perniagaan kami untuk bersama-sama
                    membangunkan produk dan / atau perkhidmatan atau melancarkan
                    kempen pemasaran;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >x. untuk berkongsi mana-mana Data Peribadi anda dengan
                    syarikat insurans yang diperlukan untuk tujuan memohon dan
                    memperoleh polisi insurans, jika perlu;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >y. untuk berkongsi mana-mana Data Peribadi anda dengan
                    institusi kewangan yang diperlukan untuk tujuan memohon dan
                    memperoleh kemudahan kredit, jika perlu;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >z. untuk tujuan audit, pengurusan risiko dan
                    keselamatan;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >aa. untuk mengesan, menyiasat dan menghalang aktiviti
                    penipuan, yang dilarang atau yang menyalahi
                    undang-undang;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >bb. untuk membolehkan kami melaksanakan tanggungjawab kami
                    dan menguatkuasakan hak kami di bawah mana-mana perjanjian
                    atau dokumen yang kami adalah pihak kepada;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >cc. untuk memindahkan atau memperuntukkan hak, kepentingan
                    dan obligasi kami di bawah mana-mana perjanjian yang
                    dimeteraikan dengan kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >dd. untuk memenuhi sebarang keperluan undang-undang atau
                    pengawalseliaan dan membuat penzahiran di bawah kehendak
                    mana-mana undang-undang, peraturan, perintah, perintah
                    mahkamah, undang-undang kecil, garis panduan, pekeliling
                    atau kod yang terpakai kepada kami;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >ee. untuk menguatkuasakan atau mempertahankan hak-hak kami
                    dan hak-hak anda di bawah, dan untuk mematuhi, kewajipan
                    kami di bawah undang-undang, perundangan dan peraturan yang
                    berkenaan;</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >ff. untuk menjalankan pengesahan dan semakan latar belakang
                    sebagai sebahagian daripada proses pengambilan pekerjaan dan
                    pemilihan yang berkaitan dengan permohonan pekerjaan anda
                    dengan kami; dan / atau</i
                  >
                </p>
              </li>
              <li>
                <p>
                  <i
                    >gg. untuk tujuan lain yang diperlukan untuk mengendalikan,
                    mengekalkan dan menguruskan perniagaan dan hubungan anda
                    dengan kami dengan lebih baik, yang kami maklumkan kepada
                    anda apabila kami mendapatkan persetujuan anda; dan anda
                    bersetuju dan membenarkan kami menggunakan dan memproses
                    Data Peribadi anda untuk Tujuan yang dikenal pasti dalam
                    Polisi ini. Sekiranya anda tidak membenarkan kami memproses
                    Data Peribadi anda untuk satu atau lebih daripada satu
                    Tujuan di atas, sila maklumkan pada kami di butiran
                    perhubungan di bawah.</i
                  >
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <i
                >2.6 Pengumpulan Data Peribadi anda oleh kami mungkin bersifat
                mandatori atau sukarela bergantung kepada Tujuan yang mana Data
                Peribadi anda dikumpulkan. Di mana ia wajib bagi anda untuk
                membekalkan Data Peribadi anda kepada kami, dan anda gagal atau
                memilih untuk tidak memberikan data tersebut kepada kami, atau
                tidak bersetuju dengan Polisi di atas, kami tidak akan dapat
                menyediakan produk dan / atau perkhidmatan atau setidaknya
                berurusan dengan anda.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>3. PENZAHIRAN</i></h2>
        <p>
          <i
            >Kami tidak akan menjual, menyewa, memindahkan atau menzahirkan
            mana-mana Data Peribadi anda kepada mana-mana pihak ketiga tanpa
            kebenaran anda. Walau bagaimanapun, kami boleh menzahirkan Data
            Peribadi anda kepada pihak ketiga berikut, untuk satu atau lebih
            daripada satu Tujuan di atas:</i
          >
        </p>
        <ul>
          <li>
            <p>
              <i
                >a. Antara Carsome dan syarikat berkaitan dan bersekutu kami
                sama ada di dalam Malaysia atau di luar negara;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >b. ahli keluarga terdekat anda dan / atau orang hubungan
                kecemasan seperti yang dimaklumkan kepada kami dari semasa ke
                semasa;</i
              >
            </p>
          </li>
          <li>
            <p><i>c. pengganti dalam hakmilik kepada kami;</i></p>
          </li>
          <li>
            <p>
              <i
                >d. mana-mana orang di bawah kewajipan kerahsiaan yang telah
                berjanji untuk memastikan kerahsiaan Data Peribadi anda telah
                kami lantik untuk melaksanakan kewajipan kami kepada anda;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >e. mana-mana pihak berhubung dengan prosiding undang-undang
                atau prosiding undang-undang yang berpotensi;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >f. juruaudit, perunding, peguam, akauntan atau penasihat
                kewangan atau profesional lain yang dilantik berkaitan dengan
                perniagaan kami secara rahsia, yang dilantik oleh kami untuk
                menyediakan perkhidmatan kepada kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >g. mana-mana pihak yang dicalonkan atau dilantik oleh kami sama
                ada secara tunggal atau bersama-sama dengan pembekal
                perkhidmatan lain, untuk tujuan mewujudkan dan mengekalkan
                pangkalan data bersama di mana kami mempunyai kepentingan
                bersama yang sah;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >h. pusat data dan / atau pelayan yang terletak di dalam atau di
                luar Malaysia untuk tujuan penyimpanan data atau sebaliknya;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >i. saluran pembayaran termasuk tetapi tidak terhad kepada
                institusi kewangan untuk tujuan menilai, mengesahkan, memberi
                kesan dan memudahkan pembayaran apa-apa amaun yang terhutang
                kepada kami berkaitan dengan pembelian produk dan / atau
                perkhidmatan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >j. agensi-agensi kerajaan, agensi penguatkuasaan undang-undang,
                mahkamah, tribunal, badan pengawal selia, pengawal selia
                industri, kementerian, dan / atau badan berkanun atau badan,
                pejabat atau perbandaran dalam mana-mana bidang kuasa, jika
                dikehendaki atau dibenarkan berbuat demikian, perintah atau
                penghakiman sesuatu mahkamah atau tribunal atau pertanyaan
                daripada pihak berkuasa yang berkenaan;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >k. rakan usaha sama/perniagaan kami, pembekal produk dan / atau
                perkhidmatan pihak ketiga, pembekal, vendor, kontraktor,
                pemproses data atau ejen, yang membekalkan produk dan / atau
                perkhidmatan yang berkaitan dengan perniagaan kami, atau
                menunaikan atau melaksanakan satu atau lebih daripada satu
                Tujuan di atas dan tujuan lain yang diperlukan untuk
                mengendalikan dan mengekalkan perniagaan kami, termasuk tetapi
                tidak terhad kepada pusat panggilan, syarikat telekomunikasi,
                syarikat logistik, syarikat teknologi maklumat dan pusat
                data;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >l. syarikat insurans untuk tujuan memohon dan memperoleh polisi
                insurans, jika perlu;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >m. institusi kewangan untuk tujuan memohon dan mendapatkan
                kemudahan kredit (jika ada);</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >n. institusi kewangan, peniaga dan organisasi kad kredit
                berkaitan dengan transaksi komersial anda dengan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >o. orang awam apabila anda menjadi pemenang dalam pertandingan
                dengan menerbitkan nama, gambar dan Data Peribadi lain tanpa
                pampasan untuk tujuan pengiklanan dan publisiti;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >p. kepada agensi pelaporan kredit atau agensi pekerjaan pihak
                ketiga sebagai sebahagian daripada proses pengambilan pekerjaan
                dan pemilihan dan/atau sebaliknya berkaitan dengan permohonan
                pekerjaan anda dengan kami;</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >q. sekiranya berlaku pelepasan, cadangan, pengambilalihan,
                penyatuan, penyusunan semula semula, pembiayaan atau penjualan
                aset yang berpotensi, dicadangkan atau sebenarnya, mana-mana
                perniagaan atau kepentingan kami, atau sekiranya berlaku
                penggulungan (“Transaksi”), Data Peribadi anda mungkin
                dikehendaki didedahkan atau dipindahkan kepada pihak ketiga
                akibat, atau berkaitan dengan, Transaksi. Anda dengan ini
                mengakui bahawa pendedahan dan pemindahan sedemikian mungkin
                berlaku dan membenarkan kami mendedahkan dan memindahkan Data
                Peribadi anda kepada pihak ketiga dan penasihat / wakilnya; dan
                / atau</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >r. mana-mana orang lain yang semunasabahnya memerlukan yang
                sama agar kami dapat mengendalikan dan mengekalkan perniagaan
                kami atau menjalankan aktiviti-aktiviti yang dinyatakan dalam
                Tujuan.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>4. KETEPATAN</i></h2>
        <p>
          <i
            >Kami berhasrat untuk menyimpan semua Data Peribadi dengan tepat,
            lengkap, tidak mengelirukan, terkini dan boleh dipercayai setakat
            mana yang boleh. Oleh itu, sebahagian besar ketepatan Data Peribadi
            anda bergantung kepada maklumat yang anda berikan. Oleh itu, ia
            adalah syarat untuk kami menyediakan produk, perkhidmatan dan / atau
            kemudahan kepada anda bahawa anda:</i
          >
        </p>
        <ul>
          <li>
            <p>
              <i
                >a. menjamin dan mengisytiharkan bahawa semua Data Peribadi yang
                dikemukakan atau akan dikemukakan kepada kami adalah tepat,
                tidak mengelirukan, dikemaskini dan lengkap dalam semua aspek
                untuk tujuan memperoleh atau menggunakan produk, perkhidmatan
                dan / atau kemudahan yang relevan, dan anda tidak menahan
                sebarang Data Peribadi yang mungkin menjadi penting dalam
                apa-apa cara dan kami diberi kuasa untuk menganggap ketepatan
                dan kemaskini Data Peribadi yang diberikan oleh anda semasa
                memproses Data Peribadi tersebut); dan</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >b. maklumkan kepada kami dengan segera apabila Data Peribadi
                yang dibekalkan kepada kami sebelum ini menjadi tidak tepat,
                tidak lengkap, mengelirukan, tidak lagi kemas kini atau
                perubahan dalam apa jua cara sekalipun dengan menghubungi kami
                di butiran perhubungan di bawah.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>5. AKSES</i></h2>
        <ul>
          <li>
            <p>
              <i
                >5.1 Tertakluk kepada pengecualian yang terdapat di bawah APDP,
                anda mempunyai hak untuk meminta akses kepada, meminta salinan,
                meminta untuk mengemaskini atau meminda, Data Peribadi anda yang
                dipegang oleh kami. Kami mungkin mengenakan bayaran yang kecil
                (jumlah sepertimana yang dibenarkan oleh APDP) untuk menampung
                kos pentadbiran yang terlibat dalam memproses permintaan anda
                untuk mengakses Data Peribadi anda.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >5.2 Berhubung dengan hak anda untuk mengakses dan / atau meinda
                Data Peribadi anda, kami berhak untuk menolak permintaan anda
                untuk mengakses dan / atau meminda Data Peribadi anda atas
                alasan yang dibenarkan di bawah undang-undang, seperti di mana
                perbelanjaan menyediakan akses kepada anda tidak sepadan dengan
                risiko privasi anda, atau di mana hak orang lain juga boleh
                dilanggar, antara sebab lain.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >5.3 Anda mempunyai hak pada bila-bila masa untuk meminta kami
                untuk mengehadkan pemprosesan dan penggunaan Data Peribadi anda
                (sebagai contoh, meminta kami untuk berhenti daripada menghantar
                sebarang bahan pemasaran dan promosi atau menghubungi anda untuk
                tujuan pemasaran).</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >5.4 Di samping itu, anda juga mempunyai hak, melalui notis
                secara bertulis, untuk memaklumkan kami tentang penarikan balik
                persetujuan anda (sepenuhnya atau sebahagian) yang diberikan
                sebelum ini kepada kami tertakluk kepada sebarang sekatan
                undang-undang, syarat kontrak dan tempoh masa yang munasabah
                bagi penarikan balik persetujuan untuk dilaksanakan.
                Bagaimanapun, penarikan balik persetujuan anda mungkin
                menyebabkan akibat-akibat undang-undang tertentu yang timbul
                daripada penarikan balik tersebut. Sehubungan dengan ini,
                bergantung pada sejauh mana penarikan balik kebenaran anda untuk
                kami memproses Data Peribadi anda, ini mungkin bermakna kami
                tidak akan dapat meneruskan hubungan anda yang sedia ada dengan
                kami dan/atau kontrak yang anda miliki dengan kami akan
                ditamatkan.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>6. PENYIMPANAN</i></h2>
        <p>
          <i
            >Mana-mana Data Peribadi anda yang diberikan kepada kami akan
            disimpan selagi tujuan yang mana Data Peribadi dikumpulkan
            berterusan. Data Peribadi anda akan dimusnahkan dari rekod dan
            sistem kami mengikut dasar penyimpanan kami sekiranya Data Peribadi
            anda tidak lagi diperlukan untuk tujuan tersebut kecuali penyimpanan
            selanjutnya diperlukan untuk memenuhi tempoh penyimpanan yang lebih
            panjang untuk memenuhi keperluan operasi, undang-undang,
            pengawalseliaan, cukai atau perakaunan.</i
          >
        </p>
        <h2><i>7. KESELAMATAN</i></h2>
        <ul>
          <li>
            <p>
              <i
                >7.1 Kami komited untuk memastikan bahawa Data Peribadi anda
                disimpan dengan selamat. Untuk mengelakkan akses atau penzahiran
                tanpa kebenaran atau risiko lain yang serupa, kami berusaha,
                jika dapat dilaksanakan, untuk melaksanakan langkah-langkah
                keselamatan teknikal, fizikal, elektronik dan prosedur yang
                sesuai selaras dengan undang-undang dan peraturan yang berkenaan
                dan standard industri untuk melindungi dan mencegah pihak yang
                tidak dibenarkan atau pemprosesan yang menyalahi undang-undang
                Data Peribadi anda, dan pemusnahan, atau kerugian secara tidak
                sengaja, kerosakan, pengubahan, pendedahan atau akses tanpa
                kebenaran kepada Data Peribadi anda.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >7.2 Kami akan membuat kemas kini yang munasabah kepada
                langkah-langkah keselamatannya dari semasa ke semasa dan
                memastikan pihak ketiga yang diberikuasa hanya menggunakan Data
                Peribadi anda untuk Tujuan yang dinyatakan dalam Polisi ini.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >7.3 Internet bukan medium yang selamat. Walau bagaimanapun,
                kami akan menyediakan pelbagai prosedur keselamatan berkaitan
                dengan Laman Web dan komunikasi elektronik anda dengan kami.
                Semua pekerja, rakan usaha sama/perniagaan, agen, kontraktor,
                vendor, pembekal, pemproses data, pembekal produk dan/atau
                perkhidmatan pihak ketiga yang mempunyai akses kepada, dan yang
                dikaitkan dengan pemprosesan Data Peribadi anda, diwajibkan
                menghormati kerahsiaan Data Peribadi anda.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >7.4 Sila maklum bahawa komunikasi melalui Internet, seperti
                e-mel / emel web tidak selamat kecuali mereka telah disulitkan.
                Komunikasi anda mungkin dihalakan melalui beberapa negara
                sebelum dihantar - ini adalah sifat World Wide Web /
                Internet.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >7.5 Kita tidak boleh dan tidak menerima tanggungjawab untuk
                sebarang akses tanpa izin atau pemintasan atau kehilangan Data
                Peribadi yang berada di luar kawalan kami yang munasabah.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>8. PEMINDAHAN KE LUAR MALAYSIA</i></h2>
        <p>
          <i
            >Kemudahan penyimpanan maklumat dan pelayan kami boleh ditempatkan
            di negara lain di luar Malaysia. Ini mungkin termasuk, tetapi tidak
            terhad kepada, contoh-contoh di mana Data Peribadi anda boleh
            disimpan di pelayan yang terletak di luar Malaysia. Di samping itu,
            Data Peribadi anda boleh dizahirkan atau dipindahkan kepada entiti
            yang terletak di luar Malaysia atau di mana anda mengakses Laman Web
            dari negara-negara di luar Malaysia. Sila maklum bahawa entiti asing
            ini boleh ditubuhkan di negara-negara yang mungkin tidak menawarkan
            tahap perlindungan data yang bersamaan dengan yang ditawarkan di
            Malaysia di bawah undang-undang Malaysia. Anda dengan ini bersetuju
            dengan nyata untuk membolehkan kami memindahkan Data Peribadi anda
            di luar Malaysia untuk tujuan tersebut. Kami akan berusaha untuk
            memastikan bahawa langkah-langkah yang munasabah diambil untuk
            memastikan bahawa semua pihak ketiga di luar Malaysia tidak akan
            menggunakan Data Peribadi anda selain sebagai sebahagian daripada
            Tujuan tersebut dan untuk melindungi privasi dan privasi Data
            Peribadi anda secukupnya.</i
          >
        </p>
        <h2><i>9. PAUTAN LUAR</i></h2>
        <ul>
          <li>
            <p>
              <i
                >9.1 Jika mana-mana bahagian Laman Web ini menghubungkan anda ke
                laman web lain, laman web tersebut tidak beroperasi di bawah
                Polisi ini dan kami tidak menerima sebarang tanggungjawab atau
                liabiliti yang timbul daripada laman web tersebut.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >9.2 Begitu juga, jika anda melanggan aplikasi, kandungan atau
                produk dari rakan strategik kami dan anda kemudiannya memberikan
                Data Peribadi anda terus kepada pihak ketiga itu, Data Peribadi
                itu akan tertakluk kepada dasar perlindungan privasi / privasi
                pihak ketiga tersebut (jika ada polisi sedemikian) dan bukan
                kepada Polisi ini.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >9.3 Kami mengesyorkan anda membaca dan memahami penyataan /
                dasar perlindungan data peribadi / privasi yang dipaparkan di
                laman web yang lain untuk memahami prosedur mereka dalam
                mengumpul, memproses, menggunakan dan mendedahkan data peribadi
                dan sebelum menyerahkan Data Peribadi anda ke laman web
                tersebut.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>10. KUKI</i></h2>
        <ul>
          <li>
            <p>
              <i
                >10.1 Kami menggunakan piawaian teknologi industri yang
                dipanggil "kuki". Kuki adalah maklumat kecil yang disimpan pada
                cakera keras komputer atau peranti anda untuk tujuan penyimpanan
                rekod dan digunakan oleh kami untuk mengesan kunjungan anda ke
                Laman Web. Kuki boleh digunakan untuk menyimpan pilihan anda
                untuk kemudahan dan kemudahan anda semasa menggunakan Laman Web
                ini. Rangkaian pengiklanan pihak ketiga boleh mengeluarkan Kuki
                berasingan mereka ke cakera keras anda semasa memaparkan iklan
                mereka.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >10.2 Jenis data aliran klik tidak diperibadikan yang dikumpul
                oleh kami melalui Kuki mungkin termasuk alamat Protokol Internet
                anda, perisian pelayar web, tarikh dan waktu lawatan ke Laman
                Web, dan sama ada permintaan anda (termasuk permintaan carian
                dan klik pautan ke bahagian Laman Web) dipenuhi dengan berjaya.
                Semua maklumat yang dikumpulkan melalui kuki bukan Data Peribadi
                dan anda tidak boleh dikenal pasti dari maklumat ini. Maklumat
                sedemikian hanya digunakan untuk tujuan mengurus dan
                menghasilkan pengalaman pengguna yang lebih baik dan untuk
                mengenal pasti bahagian untuk penambahbaikan di Laman Web.</i
              >
            </p>
          </li>
          <li>
            <p>
              <i
                >10.3 Penggunaan Kuki kini merupakan piawaian industri, dan anda
                akan mendapati ia digunakan di kebanyakan laman web utama.
                Kebanyakan pelayar pada mulanya ditubuhkan untuk menerima kuki.
                Jika anda lebih suka, anda boleh menetapkan semula pelayar anda
                sama ada untuk memaklumkan anda apabila anda telah menerima
                kuki, atau menolak untuk menerima kuki. Anda harus faham bahawa
                ciri-ciri tertentu di Laman Web tidak berfungsi dengan baik jika
                anda menetapkan pelayar anda untuk tidak menerima kuki.</i
              >
            </p>
          </li>
        </ul>
        <h2><i>11. MAKLUMAT PERHUBUNGAN</i></h2>
        <p>
          <i
            >Sekiranya anda mempunyai sebarang pertanyaan mengenai Polisi ini,
            atau mempunyai pertanyaan lanjut, atau ingin membuat aduan atau
            akses data atau permintaan pembetulan berkenaan dengan Data Peribadi
            anda, anda boleh menghubungi Pegawai Pematuhan kami di
            &lt;info@carsome.my&gt;.</i
          >
        </p>
        <h2><i>12. BAHASA</i></h2>
        <p>
          <i
            >Dalam keadaan berlakunya sebarang konflik antara Polisi Privasi
            Data Peribadi ini dalam Bahasa Inggeris dengan Polisi Privasi Data
            Peribadi ini dalam Bahasa Malaysia yang sepadan dengannya,
            terma-terma Polisi Privasi Data Peribadi dalam Bahasa Inggeris akan
            mengatasinya.</i
          >
        </p>
        <h2><i>Bertarikh: Januari 1, 2021</i></h2>
        <p></p>
      </div>
    </div>
    <div>
      <h2>1. General</h2>
      <p>
        These are the terms of use and services (“Terms”) of Carsome Sdn Bhd
        (Company No: 1101954-M). The access to and use of the services on this
        website (“the Website”) are subject to these Terms.
      </p>
      <p>
        Carsome provides an online automotive platform that allows the
        prospective buyers to research, compare, bid and purchase vehicle(s)
        listed on the Website.
      </p>
      <p>
        By accessing and using the Website, you agree to comply with and be
        bound by these Terms which shall be applicable to all Users of the
        Website. If you are using and accessing the Website for and on behalf of
        a business entity, the term “you” in these Terms shall mean the business
        entity in which you are representing in using the Website, unless the
        context does not permit.
      </p>
      <p>
        You are advised to read these Terms carefully as these affect your
        rights and liabilities under applicable laws and regulations in
        Malaysia. If you do not agree to these Terms, you should not use the
        Website.
      </p>
      <h2>2. Right to use and restrictions</h2>
      <ul>
        <li>
          <p>
            2.1.&nbsp;You are responsible for the access to and use of the
            Website, including obtaining the necessary data network access, even
            if the access is by another person.
          </p>
        </li>
        <li>
          <p>
            2.2.&nbsp;You are accessing and using the Website at your own risk.
            We shall not be liable for any damage to, or viruses or other codes
            that may affect any hardware or device, software, data or other
            property as a result of your access to and use of the Website.
          </p>
        </li>
        <li>
          <p>
            2.3.&nbsp;You may only access the Website using authorised means. It
            is your responsibility to check and ensure that you have downloaded
            and/or updated the correct software for the hardware and device for
            your access to and use of the Website. We do not guarantee that the
            Website, or any part thereof, will function as intended on any
            particular hardware or device. We are not liable if you do not have
            compatible hardware or a compatible device or if you have downloaded
            the wrong version of the software on your hardware or device.
          </p>
        </li>
        <li>
          <p>
            2.4.&nbsp;You shall access and use the Website in accordance with
            any instructions for access to and use of the Website which we may
            make from time to time, these Terms and regulations at the time
            being in force in Malaysia.
          </p>
        </li>
        <li><p>2.5.&nbsp;You shall not:</p></li>
        <li>
          <ul>
            <li>
              <p>
                (a) impersonate any person or party or falsely declare, distort
                or misrepresent your affiliation with any person or party in
                connection with the Website, or express or imply that we endorse
                any statement you make;
              </p>
            </li>
            <li>
              <p>
                (b) in any way damage or disrupt the Website and/or the
                operation of the Website;
              </p>
            </li>
            <li>
              <p>
                (c) use the Website for any fraudulent, unauthorised or unlawful
                purpose;
              </p>
            </li>
            <li>
              <p>
                (d) deliberately and knowingly provide information or content
                that is false, misleading, inaccurate, illegal, threatening,
                obscene, hateful, libellous or defamatory;
              </p>
            </li>
            <li>
              <p>
                (e) use the Website in a manner that may be contrary to our
                interests and/or the interest of other Users;
              </p>
            </li>
            <li>
              <p>
                (f) introduce or allow the introduction of computer viruses
                and/or other computer programming routines such as any viruses,
                malware, unsolicited e-mails, Trojan horses, trap doors, back
                doors, worms, time bombs or cancelbots that may damage,
                detrimentally interfere with, surreptitiously intercept or
                expropriate any system, data or personal information, relating
                to or in connection with the Website;
              </p>
            </li>
            <li>
              <p>
                (g) reproduce, duplicate, copy, sell, resell or otherwise
                exploit for any commercial purposes, any portion of, use of, or
                access to the Website;
              </p>
            </li>
            <li>
              <p>
                (h) use the Website in a manner that is in breach of any laws
                and regulations in Malaysia.
              </p>
            </li>
          </ul>
        </li>
        <li><p>2.6.&nbsp;We reserve the right to:</p></li>
        <li>
          <ul>
            <li>
              <p>
                (a) check, vet and/or control any activity, content or
                information occurring on or through the Website;
              </p>
            </li>
            <li>
              <p>
                (b) investigate any infringement of these Terms and take any
                appropriate action thereafter;
              </p>
            </li>
            <li>
              <p>
                (c) restrict your access to and use of the Website if you
                violate any of the items stated in Clause 2.5 above; and/or
              </p>
            </li>
            <li>
              <p>
                (d) report any suspicious activity concerning the possible
                transgression of any applicable law or regulation to the
                appropriate authorities and to cooperate with such authorities.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <h2>3. Warranties and Limitation of Liability</h2>
      <ul>
        <li>
          <p>
            3.1.&nbsp;Prospective buyers are advised to read and understand the
            terms and conditions of the sale and to inspect the vehicles listed
            and conduct and rely on their own searches, enquiries,
            investigations and verifications on the accuracy and correctness of
            the particulars and information provided on the Website prior to
            purchasing.
          </p>
        </li>
        <li>
          <p>
            3.2.&nbsp;All prospective buyers should also note that any
            vehicle(s) listed as available for sale herein is subject to terms
            and conditions of sale and that any of the above vehicle(s) may at
            anytime be withdrawn from the listing in the Website absolute
            discretion without any prior notice being given and for any reason
            whatsoever. The decision of the Website in relation to the proposed
            sale is final and shall not subject to challenge. Neither shall we,
            the Website nor its Agents be held liable for the contents herein in
            any manner whatsoever under any circumstances including but not
            limited to withdrawal of vehicle(s) from the sale.
          </p>
        </li>
        <li>
          <p>
            3.3.&nbsp;We may modify or discontinue the Website or any of the
            services or features of the Website, including specific listings,
            with or without notice, without liability to you, any other user or
            any third party for any reason. You understand and agree that the
            Site and its services are provided on an "AS AVAILABLE" basis.
            Carsome assumes no responsibility for the timeliness, deletion,
            mis-delivery of or failure to store any user communications.
          </p>
        </li>
      </ul>
      <h2>4. Personal data</h2>
      <p>
        Our Personal Data Protection Notice governs the use of any personal
        information that you provide to us via the Website. A copy of the
        Personal Data Protection Notice can be accessed here at the Website.
      </p>
      <p></p>
      <h2>5. Disclaimer</h2>
      <p>
        We shall not be liable for any damages whatsoever, including but without
        limitation to any direct, indirect, special, consequential, punitive or
        incidental damages, or damages for loss of use, profits, data or other
        intangibles, damage to goodwill or reputation, arising out of or related
        to the use, inability to use or failures of the Website. We expressly
        disclaim any express and implied warranties, including, without
        limitation, completeness or accuracy of any information provided or made
        available to you. We do not warrant that the Website and any and all of
        its related facilities or capabilities will be free of interruption or
        error, that defects will be corrected, or that the equipment and
        software that makes the Website available is free of viruses or other
        harmful components.
      </p>
    </div>
  </div>
</template>


<style scoped>
.container {
  padding: 24px 16px 16px 16px;
  width: 100%;
  box-sizing: border-box;
}

.lightColor {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
  color: #696c71;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
}

.switch li:nth-child(even){
  color: #696c71;
}


h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

ul {
  padding-left: 12px;
}
</style>
